import { createSelector, Selector } from 'reselect';

import { State } from '@/store';
import {
  ExpenseSuggestion,
  PayeeRequisites,
  Payout,
  PayoutGrid,
  SalaryOverview,
} from '@/store/reducers/payout';

const selectPayoutState = (state: State) => state.payoutReducer;

export const selectPayout: Selector<State, Payout | null> = createSelector(
  selectPayoutState,
  ({ payout }) => payout,
);

export const selectSalary: Selector<State, SalaryOverview | null> = createSelector(
  selectPayoutState,
  ({ salary }) => salary,
);

export const selectSuggestions:
Selector<State, ExpenseSuggestion[] | null> = createSelector(
  selectPayoutState,
  ({ suggestions }) => suggestions,
);

export const selectPayoutGrid: Selector<State, PayoutGrid | null> = createSelector(
  selectPayoutState,
  ({ grid }) => grid,
);

export const selectRequisites: Selector<State, PayeeRequisites | null> = createSelector(
  selectPayoutState,
  ({ requisites }) => requisites,
);
